/**
 * fv-gallery-ui — entry point.
 *
 * Renders the App into #root. Nothing else here; all logic lives
 * in App.tsx, components/, pages/, state/, and data/.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
